/* eslint-disable no-case-declarations */
import * as mainActionTypes from '../mainActionTypes';

const COMPANY_NAME_MAX_LENGTH = 50;
export default function businessIdeaNameReducer(state = null, action) {
  const { type, payload } = action;
  let returnState = state;
  switch (type) {
    case mainActionTypes.SET_BUSINESS_IDEA:
      const businessIdea = payload.text || '';
      returnState = businessIdea.substr(0, COMPANY_NAME_MAX_LENGTH);
      break;
    default:
  }
  return returnState;
}
